// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Source Serif 4', 'Source Serif 4 Fallback'","fontStyle":"normal"},"className":"__className_25ee46","variable":"__variable_25ee46"};